import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import APIList, { APIListWrapper } from '../components/APIList'
import DownLoadIcon from '../asset/DownLoadIcon'
import { gql, useQuery } from '@apollo/client'

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 8px;
  box-shadow: 0px 4px 16px 0px #00000029;
  overflow: hidden;
`

const Header = styled.div`
  padding: 16px 24px 16px 24px;
  background: #373a40;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  flex-shrink: 0;
`

const Title = styled.div`
  font-family: SUIT;
  font-size: 22px;
  font-weight: 700;
  line-height: 27px;
  letter-spacing: 0em;
  text-align: center;
  color: #ffffff;
`

const BodyWrapper = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  padding: 24px;
  background-color: #fff;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  overflow-y: auto;
`

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
`

const TableWrapper = styled.div`
  width: 376px;
`

const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid transparent;
`

const TableRow = styled.div`
  display: flex;
`

interface TableGrayProps {
  white?: boolean
}

const TableCell = styled.div<TableGrayProps>`
  display: flex;

  width: 188px;
  height: 40px;
  padding: 8px 0px 8px 0px;
  border: 0.5px solid #e6e6e6;
  background: ${(props) => (props.white ? '' : '#f4f5f8')};

  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  align-items: center;
  justify-content: center;
`

const Bottom = styled.div`
  display: flex;
  gap: 24px;
  justify-content: center;
`

const ButtonBox = styled.div`
  display: flex;
  padding: 8px;
  border-radius: 4px;
  gap: 4px;
  align-items: center;
  cursor: pointer;
`

const ButtonText = styled.div`
  font-family: SUIT;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  letter-spacing: 0em;
  text-align: left;
  color: #4d4d4d;
`
export const findAllHolidaysGQL = gql`
  query findAllHolidays {
    findAllHolidays {
      year
      data {
        dateName
        locdate
      }
    }
  }
`

type Holidays = {
  date: string
  name: string
}

const formatDate = (locdateStr: string) => {
  return `${locdateStr.substring(0, 4)}년 ${locdateStr.substring(4, 6)}월 ${locdateStr.substring(6, 8)}일`
}

export const DataHoliday: React.FC = () => {
  const [holidayList, setHolidayList] = useState<Holidays[]>([])
  const [selected, setSelected] = useState<string | number | null>(null)

  const {
    data: OriginHolidaysData,
    loading,
    error,
  } = useQuery(findAllHolidaysGQL)
  const [tempHolidaysData, setTempHolidaysData] = useState<any[]>([])

  useEffect(() => {
    setTempHolidaysData(OriginHolidaysData?.findAllHolidays)
  }, [OriginHolidaysData])

  useEffect(() => {
    if (tempHolidaysData) {
      const filteredData = tempHolidaysData
        .filter((v: any) => String(v.year) === String(selected))
        .map((v: any) => v.data)
        .flat()

      setHolidayList(
        filteredData.map((v: any) => {
          return { date: formatDate(v.locdate), name: v.dateName }
        })
      )
    }
  }, [selected, tempHolidaysData])

  if (loading) return <p>Loading...</p>
  if (error) return <p>Error : {error.message}</p>

  const handleDownload = () => {
    if (!selected || holidayList.length === 0) return

    const escapeCsv = (value: string) => `"${value.replace(/"/g, '""')}"`
    const header = '날짜,공휴일명'
    const rows = holidayList.map((item) =>
      [escapeCsv(item.date), escapeCsv(item.name)].join(',')
    )
    const csvContent = [header, ...rows].join('\n')

    const blob = new Blob(['\ufeff', csvContent], {
      type: 'text/csv;charset=utf-8;',
    })
    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `holiday-${selected}.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    URL.revokeObjectURL(url)
  }

  return (
    <>
      <APIListWrapper>
        <APIList
          dataList={
            tempHolidaysData && tempHolidaysData?.map((v: any) => v.year)
          }
          setSelected={setSelected}
          // apiFunc={() =>
          //   handleAPIRequest(`${process.env.REACT_APP_BACKEND_URL}/holiday`)
          // }
          noFile
          noApi
        />
      </APIListWrapper>
      <ContentWrapper>
        <Header>
          <Title>공휴일</Title>
        </Header>
        <BodyWrapper>
          {selected && (
            <Body>
              <TableWrapper>
                <Table>
                  <TableRow>
                    <TableCell style={{ borderTopLeftRadius: '4px' }}>
                      날짜
                    </TableCell>
                    <TableCell style={{ borderTopRightRadius: '4px' }}>
                      공휴일명
                    </TableCell>
                  </TableRow>
                  {holidayList.map((v, index) => (
                    <TableRow key={index}>
                      <TableCell
                        white
                        style={
                          index === holidayList?.length - 1
                            ? { borderBottomLeftRadius: '4px' }
                            : {}
                        }
                      >
                        {v.date}
                      </TableCell>
                      <TableCell
                        white
                        style={
                          index === holidayList?.length - 1
                            ? { borderBottomRightRadius: '4px' }
                            : {}
                        }
                      >
                        {v.name}
                      </TableCell>
                    </TableRow>
                  ))}
                </Table>
              </TableWrapper>
              <Bottom>
                <ButtonBox onClick={handleDownload}>
                  <DownLoadIcon />
                  <ButtonText>다운로드</ButtonText>
                </ButtonBox>
                {/* <ButtonBox>
                  <DeleteIcon />
                  <ButtonText>삭제</ButtonText>
                </ButtonBox> */}
              </Bottom>
            </Body>
          )}
        </BodyWrapper>
      </ContentWrapper>
    </>
  )
}
